import DiscountFieldDirective from './discount-field.directive.js';

angular.module('Components')
	.directive('discountField', DiscountFieldDirective);




/** WEBPACK FOOTER **
 ** ./client/components/discount-field/index.js
 **/